/**
 * Which widget on a board a piece of applied config belongs to.
 *
 * On a dashboard the filters a reader applies belong to the resource they were
 * configured on. They used to be read straight off `selectedResource` and handed to
 * every widget, so applying a filter to one resource also filtered any other widget
 * that happened to have a column of the same name.
 *
 * A report holds a single widget, so when there is nothing to tell the two apart the
 * config applies - that is the long-standing behaviour and the only sensible reading.
 */

/** The id a board resource is known by, whichever shape it arrived in. */
export const resourceIdOf = (resource) => resource?.connectionData?.id ?? resource?.id ?? null;

/**
 * The data filters a given widget should apply.
 *
 * @param appliedResource the resource the reader pressed Apply on (may be null)
 * @param widgetResourceId the id of the resource behind the widget being rendered
 * @returns the filter array for this widget, or null if the filters are not its own
 */
export function resolveWidgetDataFilters(appliedResource, widgetResourceId) {
  if (!appliedResource || !appliedResource.dataFilters) return null;

  const appliedId = resourceIdOf(appliedResource);
  if (!widgetResourceId || !appliedId) return appliedResource.dataFilters;

  return widgetResourceId === appliedId ? appliedResource.dataFilters : null;
}

export default resolveWidgetDataFilters;